module.exports = "build/assets/mobileBusiness.4b18480b.png";